// router.store.ts
import { defineStore } from "pinia"

export interface RouterState {
    projectType: 'white_label' | 'private_label' | null;
    domainOrigin: string | null;
}

const initialState = (): RouterState => ({
    projectType: null,
    domainOrigin: null
})

export const useRouterStore = defineStore({
    id: "router",
    state: initialState,

    getters: {
        getState: (state) => (key: keyof typeof state) => {
            return state[key]
        },
    },

    actions: {
        setState<K extends keyof RouterState>(payload: { key: K; value: RouterState[K] }) {
            console.log('setState', payload);
            const { key, value } = payload;
            this.$state[key] = value;
        },

        reset() {
            Object.assign(this.$state, initialState())
        },
    },
})
